export default {
  'login.welcome': 'Welcome',
  'none': 'Ismeretlen'
}



// WEBPACK FOOTER //
// ./src/lang/hu_hu.js